import Vue from 'vue';
import Card from 'src/components/Card/Card.vue';
import convertToTree from 'src/utils/treeOperations/convertToTree';
import highlighter from 'src/utils/highlighter';
import { get } from 'lodash';
import setOptionValue from 'src/store/preferences/setOptionValue';
import getRecords from 'src/utils/entityOperations/getRecords';
import debounce from 'quasar/src/utils/debounce.js';;
import fromNumberToPercent from 'src/utils/displayFormatters/fromNumberToPercent';
import arrayIsEmpty from 'src/utils/arrayOperations/arrayIsEmpty';
export default Vue.extend({
    components: { Card },
    data() {
        return {
            expandedKeysData: [],
            needle: '',
            showUpstreamBranchesOfFilteredNodes: true,
            showDownstreamBranchesOfFilteredNodes: true
        };
    },
    computed: {
        data() { return getRecords('preferences.options'); },
        treeToDisplay() {
            const { data } = this;
            if (arrayIsEmpty(data))
                return null;
            const data2 = data.filter(tn => !tn.hide_from_ui_display && tn.name);
            // @ts-ignore
            const tree = convertToTree(data2);
            if (this.needle === null || '')
                return tree;
            const needle = this.needle.toLowerCase();
            let res = [];
            const checkIfNodeHasNeedle = (node) => {
                if (node && node.name && node.name.toLowerCase().includes(needle))
                    return true;
                if (get(node, 'content.description', '').toLowerCase().includes(needle))
                    return true;
                return false;
            };
            const checkIfChildrenHaveNeedle = (node) => {
                var _a;
                if (checkIfNodeHasNeedle(node))
                    return true;
                if (node.children)
                    return Boolean((_a = node.children) === null || _a === void 0 ? void 0 : _a.find(c => checkIfChildrenHaveNeedle(c)));
                return false;
            };
            const checkIfAncestorsHaveNeedle = (node) => {
                if (checkIfNodeHasNeedle(node))
                    return true;
                if (node && node.parent_id)
                    return checkIfAncestorsHaveNeedle(data === null || data === void 0 ? void 0 : data.find(r => r.id === node.parent_id));
                return false;
            };
            const filterChildren = (arr) => {
                let arr2 = arr.filter((node) => {
                    if (node.name && node.name.toLowerCase().includes(needle))
                        return true;
                    if (this.showUpstreamBranchesOfFilteredNodes && checkIfChildrenHaveNeedle(node))
                        return true;
                    if (this.showDownstreamBranchesOfFilteredNodes && checkIfAncestorsHaveNeedle(node))
                        return true;
                });
                arr2.forEach((a) => {
                    if (a.children) {
                        a.children = filterChildren(a.children);
                    }
                });
                return arr2;
            };
            res = filterChildren(tree);
            return res;
        },
        expandedKeysComputed: {
            get() {
                const { needle, treeToDisplay, expandedKeysData } = this;
                if (needle && needle !== '')
                    return (treeToDisplay || []).map((r) => r.id);
                return expandedKeysData;
            },
            set(val) { this.expandedKeysData = val; }
        }
    },
    created() {
        this.handleChange = debounce(this.handleChange, 300);
    },
    methods: {
        fromNumberToPercent,
        highlighter,
        handleChange(id, e) {
            setOptionValue(id, e);
        }
    }
});
